/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'editworkorder': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M414.72 723.2c-11.733 11.733-27.733 18.56-44.16 18.773l-164.267 2.56a39.208 39.208 0 0 1-35.626-35.626l2.56-164.267c.213-16.64 7.04-32.427 18.773-44.16l306.56-306.56 222.72 222.72L414.72 723.2z" _fill="#2953FF"/><path pid="1" d="M749.227 388.693l-222.934-222.72 41.814-41.813a85.504 85.504 0 0 1 120.746 0L791.04 226.347a85.504 85.504 0 0 1 0 120.746l-41.813 41.6z" _fill="#FCCA1E"/><path pid="2" d="M789.333 924.8H234.667c-35.414 0-64-28.587-64-64s28.586-64 64-64h554.666c35.414 0 64 28.587 64 64s-28.586 64-64 64z" _fill="#93A8FF"/>'
  }
})
